import { render, staticRenderFns } from "./popupBanner.vue?vue&type=template&id=71ad72e1&scoped=true"
import script from "./popupBanner.vue?vue&type=script&lang=js"
export * from "./popupBanner.vue?vue&type=script&lang=js"
import style0 from "./popupBanner.vue?vue&type=style&index=0&id=71ad72e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ad72e1",
  null
  
)

export default component.exports